import { SDLUtil, RequestUtil, StringUtil } from '@/utils'

const setMyHomeProjectList = ({commit}, data) => {
  commit('SET_MYHOME_PROJECT_LIST', data)
}

const setMyHomeWorkRequestList = ({commit}, data) => {
  commit('SET_MYHOME_WORKREQUEST_LIST', data)
}

const setMyHomeNoticeList = ({commit}, data) => {
  commit('SET_MYHOME_NOTICE_LIST', data)
}

const setMyHomeQnaList = ({commit}, data) => {
  commit('SET_MYHOME_QNA_LIST', data)
}

export default {
  async GET_MYHOME_PROJECT_LIST(store, params) {
    const response = await RequestUtil.get(`${SDLUtil.API_URL}/cop/home/project/list?${StringUtil.queryStringfy(params)}`)
    setMyHomeProjectList(store, response.data)
  },

  async GET_MYHOME_WORKREQUEST_LIST(store, params) {
    const response = await RequestUtil.get(`${SDLUtil.API_URL}/cop/home/workrequest/list?${StringUtil.queryStringfy(params)}`)
    setMyHomeWorkRequestList(store, response.data)
  },

  async GET_MYHOME_NOTICE_LIST(store, params) {
    const response = await RequestUtil.get(`${SDLUtil.API_URL}/boards/notice/posts-with-paging?${StringUtil.queryStringfy({ boardId: 'notice', ...params })}`)
    setMyHomeNoticeList(store, response.data)
  },

  async GET_MYHOME_QNA_LIST(store, params) {
    const response = await RequestUtil.get(`${SDLUtil.API_URL}/boards/voc/posts-with-paging?${StringUtil.queryStringfy({ boardId: 'voc', ...params })}`)
    setMyHomeQnaList(store, response.data)
  },
}



// WEBPACK FOOTER //
// ./src/vuex/home/myHomeAction.js